export function cleanDroChangeFilter(filter, rangeParam, sortParam) {
        const filtered = Object.fromEntries(
            Object.entries(filter)
                .filter(([_, v]) => v != null && v !== '')
        );
        if (rangeParam) filtered.rangeParam = rangeParam;
        if (sortParam) filtered.sortParam = sortParam;

        return filtered;
    }